import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=52a22ff2"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Add.vue?vue&type=style&index=0&id=52a22ff2&prod&scope=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports